import { useForm } from "react-hook-form";
import { EmailRecuperarSenhaController } from "../../../Controllers/Login/LoginController";
import { replaceClass } from "../../../Tools/Classtools";

import Swal from "sweetalert2";
import { useState } from "react";

interface ForgotFormInterface {
    Email: string;
}

export function ForgotForm() {
    const { register, handleSubmit, formState, reset } = useForm();

    const [loading, setLoading] = useState(false);

    const handleForgotFormSubmit = (formData: ForgotFormInterface) => {
        setLoading(true);
        EmailRecuperarSenhaController(formData.Email).then(() => {
            reset();
            setLoading(false);
            Swal.fire({
                title: "Envio de recuperação de senha enviado com sucesso",
                icon: "success",
                customClass: {
                    confirmButton: "d-none",
                },
            }).then(() => {
                replaceClass("kt_login", "login-forgot-on", "login-signin-on");
            });
        });
    };

    return (
        <div className="login-form login-forgot">
            <div className="text-center mb-10 mb-lg-20">
                <h3 className="">Esqueceu sua senha ?</h3>
                <p className="text-muted font-weight-bold">
                    Insira seu e-mail para redefinir sua senha
                </p>
            </div>
            <form
                className="form"
                id="kt_login_forgot_form"
                onSubmit={handleSubmit(handleForgotFormSubmit)}
            >
                <div className="form-group py-3 border-bottom mb-10">
                    <input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                            formState.errors.Email && "is-invalid"
                        }`}
                        type="email"
                        placeholder="Email"
                        name="Email"
                        autoComplete="off"
                        ref={register({
                            required: "Insira o seu e-mail",
                        })}
                    />
                    <div className="invalid-feedback">
                        {formState.errors.Email
                            ? formState.errors.Email.message
                            : ""}
                    </div>
                </div>
                <div className="form-group d-flex flex-wrap flex-center">
                    <button
                        id="kt_login_forgot_submit"
                        className="btn btn-capys font-weight-bold px-9 py-4 my-3 mx-2"
                        disabled={loading}
                    >
                        Enviar
                    </button>
                    <button
                        id="kt_login_forgot_cancel"
                        className="btn btn-light-capys font-weight-bold px-9 py-4 my-3 mx-2"
                        onClick={() =>
                            replaceClass(
                                "kt_login",
                                "login-forgot-on",
                                "login-signin-on"
                            )
                        }
                        type="button"
                        disabled={loading}
                    >
                        Cancelar
                    </button>
                </div>
            </form>
        </div>
    );
}
